import {Delete} from "@mui/icons-material";
import {GridColDef} from "@mui/x-data-grid";
import React from "react";
import {StereotypeCreateDto} from "../../../../../common/apis/stereotype/StereotypeDto";
import ExtGridWrapper from "../../../../../components/grid/ExtGridWrapper";
import {ActionButtonType, GridAction} from "../../../../../components/grid/GridAction";
import {PersistentStateId} from "../../../../../store/common/Grid";
import {t} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslation} from "../../CommonTranslation";
import {StereotypesTranslationKey} from "../../stereotypes/StereotypesTranslationKey";
import {formatElementType} from "../ElementFormatter";


function createColumnDef(): GridColDef<StereotypeCreateDto>[] {
    return [
        {
            field: 'name',
            headerName: t(StereotypesTranslationKey.NAME),
            flex: 2,
            minWidth: 150},
        {
            field: 'elementType',
            headerName: t(StereotypesTranslationKey.BASE_TYPE),
            flex: 1,
            minWidth: 100,
            valueFormatter: ({value}) => formatElementType(value)
        },
    ];
}

export interface StereotypeBulkCreateGridProps {
    stereotypes: StereotypeCreateDto[],
    onDelete: (stereotype: StereotypeCreateDto) => void;
}

export default function StereotypeBulkCreateGrid(props: Readonly<StereotypeBulkCreateGridProps>) {
    const {stereotypes, onDelete} = props;

    return (
        <>
            <ExtGridWrapper
                columns={createColumnDef()}
                rows={stereotypes}
                rowCount={stereotypes.length ?? 0}
                getRowId={row => row.name}
                actions={[
                    GridAction.buttonBuilder("DELETE", ActionButtonType.IMMEDIATE, t(CommonTranslation.DELETE), <Delete/>)
                            .onClick((selectedRowIds, selectedRows) => onDelete(selectedRows[0]))
                            .build(),
                ]}
                peristentStateId={PersistentStateId.STEREOTYPES_BULK_CREATE_GRID}
                resourceId={""}
            />
        </>
    );

}
